import { AxiosProgressEvent } from 'axios'

const HALF_PROGRESS = 50
export const getProgress = (progressEvent: AxiosProgressEvent) =>
  progressEvent.total != null
    ? Math.ceil((progressEvent.loaded * 100) / progressEvent.total)
    : HALF_PROGRESS
